import { useEffect, useState } from "react";
import { Container } from "@mui/material";
import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";
import { useParams, useSearchParams } from "react-router-dom";
import isEmpty from "lodash-es/isEmpty";

import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import dayjs from "dayjs";

import SubTitle from "../../components/SubTitle";
import { getScorePasses } from "../../services/ScoreService";
import { doService } from "../../services/ServiceHelper";
import { getUserPriority } from "../../services/UserService";
import { logoutUser } from "../../services/UserService";
import { googleLogout } from "@react-oauth/google";
import { isStringEmpty } from "../../services/StringService";

import {} from "../../services/ScoreService";

const ScoreReceipt = () => {
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_jwt] = useJwtStorage();
  const { eids } = useParams();
  const [_scores, setScores] = useState([]);
  const [queryParams] = useSearchParams();

  useEffect(() => {
    initScoreReceipts();
  }, []);

  const initScoreReceipts = () => {
    const arry = eids.split(",");
    doService(getScorePasses(_school, _jwt, arry), (results) => {
      setScores(results.data);

      if (isStringEmpty(queryParams.get("print"))) {
        setTimeout(function () {
          window.print();
          window.close();
        }, 1000);
      }
    });
  };

  const handleStudentClose = () => {
    logoutUser();
    googleLogout();
    window.close();
  };

  return (
    <>
      <Container sx={{ mt: 0 }}>
        {_scores.map((p) => (
          <div className="page-break" key={p.eid}>
            <h2 style={{ marginTop: 0, marginBottom: 0 }}>
              {_school != null &&
                _school.eid === "6f97ad78-1495-4c40-81c0-5e839aceea7e" && (
                  <>Cats on Time Receipt</>
                )}
              {_school != null &&
                _school.eid !== "6f97ad78-1495-4c40-81c0-5e839aceea7e" && (
                  <>Score Receipt</>
                )}
            </h2>
            <SubTitle text={`${p.studentLastName}, ${p.studentFirstName}`} />
            <TableContainer component={Paper} sx={{ mt: 0, mb: 2 }}>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>
                      {dayjs(p.dateCreated).format("MM/DD/YY hh:mm A")}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Category</TableCell>
                    <TableCell>{p.categoryName}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Category Count</TableCell>
                    <TableCell>{p.categoryCount}

                      {!isEmpty(p.period) && (
                        <>
                        {" "} for Period {p.period}
                        </>
                      )}

                    </TableCell>
                  </TableRow>

                  {_school.eid != "" && (
                    <TableRow>
                      <TableCell>Consequence</TableCell>
                      <TableCell>
                        {p.consequenceName}<br/>
                        {!isEmpty(p.consequenceDescription) && (
                          <>
                          {p.consequenceDescription}
                          </>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <br />
            <br />
            <br />
            <br />
            <br />
            ----------------------
            {getUserPriority(_jwt) === 500 && (
              <>
              <br/>
                <Button
                  variant="contained"
                  onClick={handleStudentClose}
                  className="noprint"
                >
                  Close This Window
                </Button>
              </>
            )}
          </div>
        ))}
      </Container>
    </>
  );
};

export default ScoreReceipt;
